export default function loginForm() {
  return {
    formData: {
      userName: "",
      password: "",
      ipAddress: "",
      sessionId: "",
      allowRegHoldLogin: false,
    },
    form: {},
    showErrorMesage: false,
    message: "",
    errors: {},
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    validateForm() {
      this.errors = {};
      if (!this.formData.userName) {
        this.errors.userName = "Email id is required.";
      } else if (!this.isValidEmail(this.formData.userName)) {
        this.errors.userName = "Please enter valid email.";
      } else {
        delete this.errors["userName"];
      }

      if (!this.formData.password) {
        this.errors.password = "Password is required.";
      } else {
        delete this.errors["password"];
      }
      return Object.keys(this.errors).length === 0;
    },
      submitData() {
     
      if (this.validateForm()) {
        fetch("/api/login/login", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userName: this.formData.userName,
            password: this.formData.password,
            allowRegHoldLogin: this.formData.allowRegHoldLogin,
            ipAddress: document.getElementById("ipAddress").value,
            /* sessionId:"11"*/
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((login) => {
            if (login.isSuccess && login.loginSuccess) {
              document.location.href = '/account-dashboard';
            } else {
              this.message = login.message;
            }
          });
      }
    },
  };
}
